import { render } from "./ReviewFabs.vue?vue&type=template&id=4e8e23e2"
import script from "./ReviewFabs.vue?vue&type=script&lang=js"
export * from "./ReviewFabs.vue?vue&type=script&lang=js"

import "./ReviewFabs.vue?vue&type=style&index=0&id=4e8e23e2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/review/components/reviewer/ReviewFabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e8e23e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e8e23e2', __exports__)) {
    api.reload('4e8e23e2', __exports__)
  }
  
  module.hot.accept("./ReviewFabs.vue?vue&type=template&id=4e8e23e2", () => {
    api.rerender('4e8e23e2', render)
  })

}


export default __exports__